export default __webpack_public_path__ + "static/media/whales.26c92c8d.png";